
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false,\"sourceMap\":false}!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-ddb2e13c\",\"scoped\":true,\"hasInlineConfig\":true}!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=styles&index=0!./AdminFormCheckBox.vue")

var Component = require("!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=script&index=0!./AdminFormCheckBox.vue"),
  /* template */
  require("!!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ddb2e13c\"}!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/selector?type=template&index=0!./AdminFormCheckBox.vue"),
  /* scopeId */
  "data-v-ddb2e13c",
  /* cssModules */
  null
)
Component.options.__file = "/home/alarmplan/staging/releases/136/frontend/src/views/Admin/Components/AdminFormComponents/AdminFormCheckBox.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AdminFormCheckBox.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ddb2e13c", Component.options)
  } else {
    hotAPI.reload("data-v-ddb2e13c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/Admin/Components/AdminFormComponents/AdminFormCheckBox.vue
// module id = 276
// module chunks = 1